<template>
    <StudentAbroadFair4 :medium="76"/>
</template>

<script>
    import StudentAbroadFair4 from '@/components/pages/StudyAbroadFair4.vue'
export default {
    components:{
        StudentAbroadFair4,
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/VirtualFair/Coimbatore.vue